import { PortalExtension } from './contract';

// This implementation must remain import-free at runtime in deployed builds.
export const portalExtension: PortalExtension = {
  prepare() {
    return undefined;
  },
};
